// extracted by mini-css-extract-plugin
export var askRedoIcon = "_8-f";
export var askRedoTag = "_8-8";
export var askRedoText = "_8-e";
export var brandGroup = "_8-2";
export var chevron = "_8-p";
export var chevronActive = "_8-q";
export var chevronDown = "_8-l";
export var divider = "_8-r";
export var exitIcon = "_8-b";
export var exitTag = "_8-7";
export var exitText = "_8-d";
export var header = "_8-0";
export var logo = "_8-4";
export var navBar = "_8-1";
export var productIcon = "_8-9";
export var productName = "_8-c";
export var productTag = "_8-5";
export var profileAvatar = "_8-h";
export var profileGroup = "_8-g";
export var profileImage = "_8-i";
export var profileInitials = "_8-j";
export var progressFill = "_8-t";
export var progressTrack = "_8-s";
export var rightGroup = "_8-3";
export var stepLabel = "_8-n";
export var stepLabelActive = "_8-o";
export var stepLabels = "_8-m";
export var storeName = "_8-k";
export var themeIcon = "_8-a";
export var themeTag = "_8-6";